/* eslint-disable check-file/filename-blocklist */
import type { GraphQLTaggedNode } from 'relay-runtime';

import { SpaceNameQuery } from './SpaceNameQuery.graphql.ts';

export const getSpaceNameFromResults = (results: any): any => {
	const errors = results.filter((result) => result.error).map((result) => result.error);
	if (errors.length) {
		throw new Error(errors.join('\n\n'));
	}
	return results[0]?.data?.space?.name || '';
};

export const getSpaceNameQueryProps = (
	spaceKey: any,
): {
	query: GraphQLTaggedNode;
	variables: {
		spaceKey: any;
	};
	skip: boolean;
}[] => {
	return [
		{
			query: SpaceNameQuery,
			variables: { spaceKey },
			skip: !spaceKey,
		},
	];
};
